<template>
    <PublicLandingPage :page="landingPages.cupcakes" />
</template>

<script setup lang="ts">
import { landingPages } from '~/fixtures';
</script>
